/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * StudentAssignmentPerformance
 *
 * @file StudentAssignmentPerformanceStyle.jsx
 * @author Mohamed yasar arabath M
 * @since 1.0.0
 */
import { makeStyles } from '@material-ui/core/styles';
import mixins from '../../../assets/styles/mixins.scss';
import CommonStyles from '../../../assets/styles/CommonStyles';

const {
  subtitle2
} = CommonStyles();

const useStudentAssignmentPerformaceStyle = makeStyles(() => ({
  subtitle2,
  backButton: {
    color: mixins.color_text_primary,
    fontFamily: "'PlusJakartaSans-SemiBold', sans-serif",
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: 600,
    minWidth: 'unset',
    width: 'fit-content',
    borderRadius: 24,

    '& span': {
      minWidth: 'unset'
    }
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16
  },
  rowSpaceBetween: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  wrapperCardContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 16
  },
  flexGrow: {
    flexGrow: 1,
    flexBasis: '50%'
  },
  topicsCoveredLabel: {
    color: '#171717',
    fontFamily: "'PlusJakartaSans-SemiBold', sans-serif",
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: 600
  },
  scrollBox: {
    padding: '8px 0',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    maxHeight: 200,
    overflow: 'auto'
  },
  title: {
    color: mixins.color_text_primary,
    fontFeatureSettings: '\'liga\' off',
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize28,
    fontStyle: 'normal',
    fontWeight: mixins.fontWeight500,
    lineHeight: '128.571%',
    letterSpacing: '-0.56px'
  },
  assignmentNameContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8
  },
  checkIcon: {
    color: '#37B866',
    verticalAlign: 'middle',
    marginRight: 4
  },
  errorIcon: {
    color: '#FFAB00',
    verticalAlign: 'middle',
    marginRight: 4
  }
}));

export default useStudentAssignmentPerformaceStyle;
